import {
  BOM_IMPORT_FILE_ACCEPT,
  BOM_IMPORT_XLS_MIME,
  BOM_IMPORT_XLSX_MIME,
} from '@/shared/lib/bomImportFileTypes'

export const SHIPMENT_SKU_CSV_MIME = 'text/csv'

export const SHIPMENT_SKU_FILE_ACCEPT = `${BOM_IMPORT_FILE_ACCEPT},.csv,${SHIPMENT_SKU_CSV_MIME}`

function hasAllowedShipmentSkuExtension(fileName: string): boolean {
  const lowerCaseFileName = fileName.toLowerCase()
  return (
    lowerCaseFileName.endsWith('.xlsx') ||
    lowerCaseFileName.endsWith('.xls') ||
    lowerCaseFileName.endsWith('.csv')
  )
}

function fileNameHasExtension(fileName: string): boolean {
  const trimmed = fileName.trim()
  const lastDot = trimmed.lastIndexOf('.')
  return lastDot > 0 && lastDot < trimmed.length - 1
}

export function isAllowedShipmentSkuFile(file: File): boolean {
  if (fileNameHasExtension(file.name)) {
    return hasAllowedShipmentSkuExtension(file.name)
  }

  return (
    file.type === BOM_IMPORT_XLSX_MIME || file.type === BOM_IMPORT_XLS_MIME
  )
}
